export var CLEAR_INITIALIZATION = "@@firekit/INITIALIZATION@CLEAR_INITIALIZATION";